import React from 'react'
import { navigate } from 'gatsby-link'
import Layout from '../../components/Layout'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import './contact.css'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isValidated: false }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      }),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch(error => alert(error))
  }

  render() {
    return (
      <Layout>
        <div className="contact-page">
          <div className="contact-hero">
            <div className="contact-hero-content">
              <h1 className="contact-hero-title">Let's Connect</h1>
              <p className="contact-hero-description">
                I'm always open to discussing new opportunities, interesting projects, or just having a chat about technology and software engineering.
              </p>
            </div>
          </div>
          
          <div className="contact-content">
            <div className="contact-info">
              <div className="glass-card contact-info-card">
                <h3>Get In Touch</h3>
                <p>Ready to start a conversation? I'd love to hear from you.</p>
                
                <div className="contact-links">
                  <a href="https://github.com/amazzalel-habib" target="_blank" rel="noopener noreferrer" className="glass-button contact-link">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
                    </svg>
                    GitHub
                  </a>
                  <a href="https://www.linkedin.com/in/amazzal/" target="_blank" rel="noopener noreferrer" className="glass-button contact-link">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    LinkedIn
                  </a>
                  <a href="https://calendly.com/amazzal" target="_blank" rel="noopener noreferrer" className="glass-button contact-link">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
                    </svg>
                    Schedule a Meeting
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <div className="glass-card contact-form-card">
                <form
                  name="contact"
                  method="post"
                  action="/contact/thanks/"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={this.handleSubmit}
                  className="contact-form"
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <div hidden>
                    <label>
                      Don't fill this out:{' '}
                      <input name="bot-field" onChange={this.handleChange} />
                    </label>
                  </div>
                  
                  <h3 className="form-title">Send Message</h3>
                  
                  <div className="form-field">
                    <TextField
                      className="glass-input"
                      type="text"
                      label="Your Name"
                      name="name"
                      onChange={this.handleChange}
                      id="name"
                      required={true}
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  
                  <div className="form-field">
                    <TextField
                      className="glass-input"
                      type="email"
                      label="Email Address"
                      name="email"
                      onChange={this.handleChange}
                      id="email"
                      required={true}
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  
                  <div className="form-field">
                    <TextField
                      className="glass-input"
                      multiline
                      rows={4}
                      label="Your Message"
                      name="message"
                      onChange={this.handleChange}
                      id="message"
                      required={true}
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  
                  <div className="form-field">
                    <Button 
                      type="submit" 
                      className="glass-submit-button"
                      size="large"
                      fullWidth
                    >
                      Send Message
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}